import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full bg-brand-black my-auto px-4 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-8 my-auto py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-4 px-2 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-brand-lime text-2xl font-medium mx-auto" }, "Installation Required"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "The Pineapple Lifestyle app is now available as a Progressive Web App that must be installed by adding it to your home screen. ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col space-y-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/pwa/1.png",
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/pwa/2.png",
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/pwa/3.png",
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col space-y-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/pwa/android-1.jpg",
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-md bg-brand-dark-gray p-3 px-4 space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-brand-light-gray text-center" }, "If you miss or do not see the automatic prompt to install you can manually install the PWA from the Chrome context menu.")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/pwa/android-2.jpg",
  alt: ""
}, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

import {
  IonContent,
  IonPage, isPlatform, useIonRouter,
} from '@ionic/vue';
import {ref} from 'vue';
import PineappleApp from "@/views/PineappleApp.vue";
import LogoMark from "@/components/LogoMark.vue";
import {AccountType} from "@/definitions/AccountType";



export default /*#__PURE__*/_defineComponent({
  __name: 'PWARequired',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(LogoMark, { class: "mx-auto" }),
              _hoisted_3,
              (_unref(isPlatform)('ios'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
                : _createCommentVNode("", true),
              (_unref(isPlatform)('android'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})